import { Member } from './Member';
import { BaseView } from './BaseView';
import { registerSchema } from './transform';

export class Message {
  Id: number = 0;
  Guid: string = '';
  DateCreated: Date = new Date();
  Subject: string = '';
  Member: Member = new Member();

  IsRead: boolean = false;
  IsDeleted: boolean = false;
  IsFlirt: boolean = false;
  LastUpdate: Date = new Date();
  LastText: string = '';
  HasReplies: boolean = false;
  IsLastFromMe: boolean = false;
  IsOriginalSender: boolean = false;
  IsOtherMemberNew: boolean = false;
}

export class MessagesView extends BaseView {
  MessageItems: Message[] = [];

}

registerSchema(Message, {
  DateCreated: 'date',
  LastUpdate: 'date',
  Member: Member,
});

registerSchema(MessagesView, {
  MessageItems: [Message],
});
